import { IconButton, Stack, useTheme } from "@mui/material";
import { ChevronRight } from "lucide-react";
import type { FC } from "react";
import { DashboardSkeleton } from "web_myplann/Dashboard/Components/DashboardSkeleton";
import { FaultyFinancialBalance } from "web_myplann/Dashboard/Components/FaultyFinancialBalance";
import { FinancialBalanceEmptyCard } from "web_myplann/Dashboard/Components/FinancialBalanceEmptyCard";
import { FinancialBalanceSummaryCard } from "web_myplann/Dashboard/Components/FinancialBalanceSummaryCard";
import { useFinancialBalanceNavigation } from "web_myplann/Dashboard/Hooks/useFinancialBalanceNavigation";
import {
	Resources,
	useResource,
} from "web_myplann/Infrastructure/Translations/Resources";
import { SectionLabelRow } from "web_myplann/Shared/Components/SectionLabelRow";
import { useFinancialBalance } from "web_myplann/Shared/Hooks/useFinancialBalance";

const R = Resources.Dashboard.FinancialBalance;

export const FinancialBalanceV2: FC = () => {
	const theme = useTheme();
	const { t } = useResource();
	const { goToDetail, goToStart } = useFinancialBalanceNavigation();

	const { isLoading, hasNoData, hasNoBalance, incomeSum, expenseSum, balance } =
		useFinancialBalance();

	if (hasNoData && !isLoading) {
		return <FaultyFinancialBalance />;
	}

	if (isLoading) {
		return (
			<Stack px={1.6}>
				<DashboardSkeleton height={200} />
			</Stack>
		);
	}

	return (
		<Stack>
			<SectionLabelRow
				title={t(R.title)}
				rightAction={
					!hasNoBalance && (
						<IconButton
							variant="ghost"
							aria-label={t(R.detail)}
							onClick={goToDetail}
							sx={{ p: 0 }}
						>
							<ChevronRight
								size={theme.iconSize.md}
								color={theme.palette.blue[600]}
							/>
						</IconButton>
					)
				}
			/>
			<Stack px={1.6} pb={1.6}>
				{hasNoBalance ? (
					<FinancialBalanceEmptyCard onClick={goToStart} />
				) : (
					<FinancialBalanceSummaryCard
						income={incomeSum}
						expense={expenseSum}
						balance={balance}
						onClick={goToDetail}
					/>
				)}
			</Stack>
		</Stack>
	);
};
